import { CustomerDocument } from '@graphcommerce/magento-customer'
import { useCustomerQuery } from '@graphcommerce/magento-customer/hooks'
import { useCopilotKit } from '@copilotkit/react-core/v2'
import { useEffect } from 'react'
import { SignupOrCheckout } from '../components/AI/SignupOrCheckout'

function SignupFormRenderer({ status }: { status: string; args: Record<string, unknown> }) {
  const { data } = useCustomerQuery(CustomerDocument)
  const isLoggedIn = Boolean(data?.customer?.email)

  if (isLoggedIn) return null
  if (status === 'inProgress') return null
  return <SignupOrCheckout />
}

export function useShowSignupFormAction() {
  const { copilotkit } = useCopilotKit()
  useEffect(() => {
    const core = copilotkit as { addHookRenderToolCall: (r: object) => void }
    core.addHookRenderToolCall({
      name: 'showSignupForm',
      args: null,
      render: SignupFormRenderer,
    })
  }, [copilotkit])
}
